<template>
    <div class="slider" ref="slider" :style="{ width: sliderWidth }">
        <div
            v-for="(item, index) in items"
            :style="{
                width: itemsWidth[index] + '%',
                background: backgroundColors[index]
            }"
            ref="items"
            class="item"
            :key="index"
        >
            <div class="flex flex-col justify-between h-full">
                <span class=" min-h-2"
                    ><strong>{{
                        item.name !== "" ? item.name : "-----"
                    }}</strong>
                </span>
                <span class=" min-h-2"
                    ><strong>{{ Math.floor(itemsPercentage[index]) }}%</strong>
                </span>
            </div>

            <div
                ref="percentageTrigger"
                v-if="index !== items.length - 1"
                class="pull"
                @mousedown="event => addResizeEvent(event, index)"
            >
                <!-- pull -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Slider",
    props: {
        items: {
            type: Array
        }
    },
    mounted() {
        this.initItemsWidth();
        window.addEventListener("resize", this.handleWindowResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleWindowResize);
    },

    data() {
        return {
            sliderWidth: 100 + "%",
            itemsWidth: [],
            itemsPercentage: [],
            startDrag: 0,
            initialSlidingItemWidth: 0,
            initialNextSlidingItemWidth: 0,
            nextSiblingMax: 0,
            previousSiblingMax: 0,
            previousSiblingWidth: 0,
            /*
      backgroundColors: ['AliceBlue', 'AntiqueWhite', 'Aqua', 'Aquamarine', 'Blue' , 'BlueViolet', 'Crimson', 'Coral'
      , 'Orange', ' LawnGreen', 'Yellow', 'YellowGreen', 'SpringGreen', 'Teal','Violet', 'Tomato', 'Black'
      ],
      */
            backgroundColors: [
                "#63b598",
                "#ce7d78",
                "#ea9e70",
                "#a48a9e",
                "#c6e1e8",
                "#648177",
                "#0d5ac1",
                "#f205e6",
                "#1c0365",
                "#14a9ad",
                "#4ca2f9",
                "#a4e43f",
                "#d298e2",
                "#6119d0",
                "#d2737d",
                "#c0a43c",
                "#f2510e",
                "#651be6",
                "#79806e",
                "#61da5e",
                "#cd2f00",
                "#9348af",
                "#01ac53",
                "#c5a4fb",
                "#996635",
                "#b11573",
                "#4bb473",
                "#75d89e",
                "#2f3f94",
                "#2f7b99",
                "#da967d",
                "#34891f",
                "#b0d87b",
                "#ca4751",
                "#7e50a8",
                "#c4d647",
                "#e0eeb8",
                "#11dec1",
                "#289812",
                "#566ca0",
                "#ffdbe1",
                "#2f1179",
                "#935b6d",
                "#916988"
            ]
        };
    },

    methods: {
        handleWindowResize() {
            this.initItemsWidth();
        },
        initItemsWidth() {
            let rest = 0;
            this.itemsWidth = this.items.map((item, index) => {
                const itemWidth =
                    this.sliderWidth.split("%")[0] / this.items.length;
                const flooredValue = Math.floor(itemWidth);
                rest = itemWidth - flooredValue + rest;
                return index === this.items.length - 1
                    ? flooredValue + rest
                    : flooredValue;
            });
            this.backgroundColors === this.items.length - 1;
        },

        addResizeEvent(event, index) {
            event.preventDefault();
            this.initialSlidingItemWidth = this.$refs.items[
                index
            ].getBoundingClientRect().width;
            if (index !== 0) {
                this.previousSiblingMax =
                    this.$refs.items[index - 1].getBoundingClientRect().left +
                    this.$refs.items[index - 1].getBoundingClientRect().width +
                    this.caluculateOnePercent();
                this.previousSiblingWidth = this.$refs.items[
                    index - 1
                ].getBoundingClientRect().width;
            } else {
                this.previousSiblingMax = this.$refs[
                    "slider"
                ].getBoundingClientRect().left;
            }

            this.nextSiblingMax =
                this.$refs.items[index + 1].getBoundingClientRect().right -
                this.caluculateOnePercent();

            this.initialNextSlidingItemWidth = this.$refs.items[
                index + 1
            ].getBoundingClientRect().width;

            this.startDrag = event.clientX;

            const handleMove = event => {
                this.handleMouseMove(index, event);
            };

            window.addEventListener("mouseup", event => {
                event.preventDefault();
                this.$emit(
                    "onChange",
                    this.$refs.items.map(
                        (item, index) => this.itemsPercentage[index]
                    )
                );
                window.removeEventListener("mousemove", handleMove);
            });
            window.addEventListener("mousemove", handleMove);
        },

        handleMouseMove(index, event) {
            if (
                this.previousSiblingMax < event.clientX &&
                event.clientX < this.nextSiblingMax
            ) {
                this.$set(
                    this.itemsWidth,
                    index,
                    this.calculatePercentages(
                        this.initialSlidingItemWidth +
                            (event.clientX - this.startDrag)
                    )
                );

                this.$set(
                    this.itemsWidth,
                    index + 1,
                    this.calculatePercentages(
                        this.initialNextSlidingItemWidth -
                            (event.clientX - this.startDrag)
                    )
                );
            }
            if (this.previousSiblingMax > event.clientX) {
                this.$set(
                    this.itemsWidth,
                    index,
                    this.calculatePercentages(this.caluculateOnePercent())
                );
                this.$set(
                    this.itemsWidth,
                    index + 1,
                    this.calculatePercentages(
                        this.initialSlidingItemWidth +
                            this.initialNextSlidingItemWidth -
                            this.caluculateOnePercent()
                    )
                );
            }
            if (event.clientX > this.nextSiblingMax) {
                this.$set(
                    this.itemsWidth,
                    index,
                    this.calculatePercentages(
                        this.initialSlidingItemWidth +
                            this.initialNextSlidingItemWidth -
                            this.caluculateOnePercent()
                    )
                );

                this.$set(
                    this.itemsWidth,
                    index + 1,
                    this.calculatePercentages(this.caluculateOnePercent())
                );
            }
        },
        calculatePercentages(width) {
            return (
                (width * 100) /
                this.$refs["slider"].getBoundingClientRect().width
            );
        },
        caluculateOnePercent() {
            return this.$refs["slider"].getBoundingClientRect().width / 100;
        }
    },
    watch: {
        itemsWidth(newValue) {
            newValue.forEach((item, index) => {
                // let decimal = item - Math.floor(item).toFixed(2);
                this.itemsPercentage[index] = Math.round(item);
            });
        },

        items() {
            this.initItemsWidth();
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.slider {
    margin: 0 auto;
    display: flex;
}
.item:first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
}
.item:last-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}
.slider .item {
    background: #e2e8f0;
    box-sizing: border-box;
    /*overflow: hidden;*/
    text-align: center;
    /*border: 1px solid darkgray;*/
    position: relative;
    min-height: 60px;
    line-height: 38px;
    display: inline-block;
    padding: 10px;
}

.slider .item span:first-of-type {
    line-height: 22px;
}
/*transition: width 0.25s ease;*/
.slider .item .pull {
    box-sizing: border-box;
    position: absolute;
    right: -20px;
    background: darkgray;
    z-index: 2;
    cursor: col-resize;
    user-select: none;
    border: gray 4px solid;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    top: 50%;
    transform: translateY(-50%);
}
/*
span {
  overflow: hidden;
  text-overflow: ellipsis;
}
*/
</style>
